import {
	Button,
	TextField,
	Box,
} from "@mui/material"
import { useEffect, useRef, useState} from "react"
import axios from "axios"
import { useNavigate, useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setUser } from "../../reducers/userSlice"
import { useSnackbar } from "notistack"
import AuthorInviteInput from "./AuthorInviteInput"
import {
	normalizeUserWorkspace,
	openPrimaryWorkspace,
} from "../../reducers/workspaceSlice"

export default function RegistrationForm() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [firstName, setFirstName] = useState("")
	const [lastName, setLastName] = useState("")
	const [inviteKey, setInviteKey] = useState("")
	const [showKeyInput, setShowKeyInput] = useState(false)
	const { enqueueSnackbar } = useSnackbar()
	const { search } = useLocation()
	const queryParams = new URLSearchParams(search)
	const pricing = queryParams.get("pricing")
	const keyId = queryParams.get("key")
	const registered = queryParams.get("registered")
	const firstNameInputFocusRef = useRef()

	const setFirstWorkspaceForNewUser = (userWithUserWorkspaces) => {
		dispatch(setUser(userWithUserWorkspaces))
		const firstWorkspace = userWithUserWorkspaces.userWorkspaces[0]
		const normalizedWorkspace = normalizeUserWorkspace(firstWorkspace)

		dispatch(openPrimaryWorkspace(normalizedWorkspace))
			.then(() => navigate("/dashboard"))
			.catch(err => console.log(err))
	}

	const handleSubmit = () => {
		if (!firstName && !lastName) {
			enqueueSnackbar("First name and last name are required", {
				variant: "error",
				autoHideDuration: 2000,
			})
			return
		}
		if (!firstName) {
			enqueueSnackbar("First name is required", {
				variant: "error",
				autoHideDuration: 2000,
			})
			return
		}
		if (!lastName) {
			enqueueSnackbar("Last name is required", {
				variant: "error",
				autoHideDuration: 2000,
			})
			return
		}
		if((pricing === "key" || pricing === "key-upgrade") && keyId) {
			axios
				.post("/api/user/create-invited", {
					firstName,
					lastName,
					keyUUID: keyId
				})
				.then(({data: user}) => {
					setFirstWorkspaceForNewUser(user)
				})
		} else if((pricing === "author" && keyId) || inviteKey !== "") {
			axios
				.post("/api/user/create-author", {
					firstName,
					lastName,
					keyUUID: pricing === "author" ? keyId : inviteKey
				}).then(({data: user}) => {
					setFirstWorkspaceForNewUser(user)
				}).catch(({response}) => {
					enqueueSnackbar(response.data ? response.data : "Unable to verify invitation code, please contact support", {
						variant: "error",
						autoHideDuration: 2000,
					})
				})
		} else {
			axios
				.put("/api/user/register", {
					firstName,
					lastName,
					createNewCustomer: registered !== "true",
				})
				.then(({ data: user }) => {
					if(pricing === "free") {
						//manually set isSubscribing to false
						axios.patch("/api/user/issubscribing/false")
							.then(({data: updatedFreeUser}) => {
								// ensure the isSubscribing value is set to false on the client-side
								const combinedUserObj = {...updatedFreeUser, userWorkspaces: user.userWorkspaces }
								setFirstWorkspaceForNewUser(combinedUserObj)
							})
					} else if (pricing === "key") {
						//isSubscribing gets set to "false" in server-side service method
						setFirstWorkspaceForNewUser(user)
					} else {
						//isSubscribing will be updated further along in the subscription flow
						dispatch(setUser(user))
						navigate("/prices" + (pricing ? `?pricing=${pricing}` : ""))
					}
				})
		}
	}

	useEffect(() => {
		firstNameInputFocusRef.current.focus()
		if(["key", "key-upgrade", "author"].includes(pricing)) {
			setShowKeyInput(true)
			if(keyId !== "") {
				setInviteKey(keyId)
			}
		}
	}, [])

	return (
		<>

			<Box sx={{
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				gap: "1rem",
				width: "100%"
			}}>
				<Box sx={{
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					width: "50%",
					justifyContent: "center",
					marginTop: "2rem",
					flex: "0 0 60%",
				}}>
					<TextField
						fullWidth
						required
						className="tunedTextField"
						id="firstname"
						label="First Name"
						onChange={(e) => setFirstName(e.target.value)}
						value={firstName}
						ref={firstNameInputFocusRef}
					/>
					<TextField
						fullWidth
						required
						className="tunedTextField"
						id="lastname"
						label="Last Name"
						onChange={(e) => setLastName(e.target.value)}
						value={lastName}
					/>
				</Box>
				<Box sx={{
					marginTop: "2rem",
					width: "100%",
					//flex: "0 0 30%"
				}}>
					<AuthorInviteInput
						open={showKeyInput}
						inviteKey={inviteKey}
						setInviteKey={setInviteKey}
					/>
				</Box>
			</Box>
			<Button
				sx={{ fontSize: "1rem", lineHeight: "1.18rem", paddingY: "12px", width: "100%" }}
				variant={"contained"}
				onClick={handleSubmit}
				disabled={!firstName || !lastName}
			>
				Next
			</Button>
		</>
	)
}
